<template>
  <v-row v-if="team.publish_enabled">
    <v-col cols="6"
           sm="3">

      <v-menu v-model="releaseMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              bottom
              offset-y
              min-width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="formattedReleaseAt"
                        label="Release on"
                        placeholder=" "
                        prepend-icon="fal fa-calendar"
                        readonly
                        clearable
                        v-bind="attrs"
                        v-on="on">
          </v-text-field>
        </template>
        <v-date-picker v-model="form.release_at"
                       :min="minReleaseAt"
                       @input="releaseMenu = false; expiresMenu = true">
        </v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="6"
           sm="3">
      <v-menu v-model="expiresMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              bottom
              offset-y
              min-width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="formattedExpiresAt"
                        label="Expire on"
                        placeholder=" "
                        prepend-icon="fal fa-calendar"
                        readonly
                        clearable
                        v-bind="attrs"
                        v-on="on">
          </v-text-field>
        </template>
        <v-date-picker v-model="form.expires_at"
                       :min="minExpiresAt()"
                       @input="expiresMenu = false">
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>
<script>
import {mapGetters} from 'vuex';
import moment from 'moment-timezone';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      releaseMenu: false,
      expiresMenu: false,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    minReleaseAt() {
      return moment().format('YYYY-MM-DD');
    },
    formattedReleaseAt: {
      get() {
        if (this.form.release_at) {
          return moment(this.form.release_at, 'YYYY-MM-DD').format('ddd, MMM D, YYYY')
        }
        return '';
      },
      set: function (newValue) {
        if (!newValue) {
          this.form.release_at = null;
        }
          //console.log('set formattedReleaseAt', newValue);
      }
    },
    formattedExpiresAt: {
      get() {
        if (this.form.expires_at) {
          return moment(this.form.expires_at, 'YYYY-MM-DD').format('ddd, MMM D, YYYY')
        }
        return '';
      },
      set: function (newValue) {
        if (!newValue) {
          this.form.expires_at = null;
        }
        //console.log('set formattedExpiresAt', newValue);
      }
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    minExpiresAt() {
      return moment(this.minReleaseAt, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD');
    },
    fetchData() {

    },
  }
}
</script>
